
import DoraAI from "../insights/DoraAI";

export { Page }

function Page() {
  return <DoraAI />;
}
